import { GenerateModalWithSuspense } from "@libs/modal-panels/modal-registry-helpers";
import { iModalProps } from "@libs/modal-panels/modal-registry-model";
import React from "react";

const AddActivityModal = React.lazy(() => import("./add-activity.modal"));

const AddActivity: iModalProps<typeof AddActivityModal> = {
  name: "add-activity",
  component: GenerateModalWithSuspense(AddActivityModal),
};

export default AddActivity;
